import { Mark, mergeAttributes } from '@tiptap/core';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    spoiler: {
      toggleSpoiler: () => ReturnType;
    };
  }
}

export const SpoilerExtension = Mark.create({
  name: 'spoiler',
  priority: 1000,
  exitable: true,

  parseHTML() {
    return [
      {
        tag: 'spoiler',
      },
    ];
  },

  renderHTML() {
    return [
      'spoiler',
      mergeAttributes(this.options.HTMLAttributes, {
        class: `spoiler`,
      }),
      0,
    ];
  },

  addKeyboardShortcuts() {
    return {
      'Mod-i': () => this.editor.commands.toggleSpoiler(),
    };
  },

  addCommands() {
    return {
      toggleSpoiler:
        () =>
        ({ chain, state }) => {
          const { selection } = state;
          if (selection.empty) {
            const marksAfterCursor = selection.$from.nodeAfter?.marks || [];

            const isNextSpoil = marksAfterCursor.some((mark) => mark.type.name === 'spoiler');

            if (isNextSpoil) {
              return chain()
                .focus()
                .toggleMark(this.name, {}, { extendEmptyMarkRange: true })
                .focus(state.selection.head)
                .run();
            }
          }

          return chain().focus().toggleMark(this.name).focus(state.selection.head).run();
        },
    };
  },
});
